if (!customElements.get("social-media-highlights-slider")) {
  class SocialMediaHighlightsSlider extends HTMLElement {
    constructor() {
      super();

      /** Store Content Card before initilation */
      this.slideContent = this.querySelector('.section__social-media-highlights--content-card');

      /** Swiper opts & init */
      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};
      const swiperLayout = this.getAttribute("data-swiper-layout") || "default";

      this.sliderItem = this.querySelector('.swiper');

      /**
       * `??`, not `||`, for both gap values: a 0px gap is a real choice here
       * (the images are meant to touch), and `0 || 2` would silently restore a
       * 2px gutter. slidesPerView is read from the section too, so mobile can
       * show a fraction of the next slide as a peek instead of a hard-coded 1.
       */
      this.sliderOptions = {
        slidesPerView: swiperOptions.slidesPerViewMobile ?? 1,
        spaceBetween: swiperOptions.spaceBetweenMobile ?? 2,
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop ?? 2
          },
          1100: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 4,
            spaceBetween: swiperOptions.spaceBetweenDesktop ?? 2
          }
        },
        on: {
          afterInit: () =>
            this.querySelector(".swiper-smh").removeAttribute("style")
        }
      };

      if (swiperOptions.autoplaySpeed != 0 && swiperLayout === "default") {
        /**
         * "Autoplay speed" from the customizer is the interval between slides,
         * so it belongs on autoplay.delay. It used to be passed as `speed` (the
         * transition duration) alongside `delay: 0`, which never waits the
         * chosen number of seconds. Transition duration is left at the Swiper
         * default so the slide advances rather than crawling for the whole
         * interval. Default matches the schema default of 7 seconds.
         */
        this.sliderOptions = {
          autoplay: {
            delay: swiperOptions.autoplaySpeed || 7000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          ...this.sliderOptions
        };
      }

      if (swiperLayout === "default" ) {
        this.sliderOptions = {
          loop: true,
          ...this.sliderOptions
        };
      }

      if (swiperLayout === "stacked") {
        this.sliderOptions = {
          navigation: {
            prevEl: ".swiper-button--prev",
            nextEl: ".swiper-button--next"
          },
          ...this.sliderOptions
        };
      }

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', this.init.bind(this));
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      /**
       * Every setting change in the customizer fires shopify:section:load. Without
       * tearing the old instance down first, each change stacked another Swiper on
       * the same element and the previous ones kept running their own autoplay, so
       * a new interval never took effect.
       */
      if (this.swiper && !this.swiper.destroyed) {
        this.swiper.destroy(true, true);
      }

      this.swiper = new Swiper(this.sliderItem, this.sliderOptions);
      this.toggleSlideContentCard();
    }

    /** Hide / Show Content Card */
    toggleSlideContentCard() {
      let swiperInitialized = false;
      if (DeviceDetector.isMobile()) {
        this.swiper.removeSlide(2);
      }

      const updateSlideContent = () => {
        if (swiperInitialized) {
          if (DeviceDetector.isMobile()) {
            this.swiper.removeSlide(2);
          } else {
            this.swiper.addSlide(2, this.slideContent)
          }
        }
      };

      updateSlideContent();

      window.addEventListener(
        "resize",
        debounce(() => {
          updateSlideContent();
        }, 200)
      );

      this.addEventListener("swiper:init", () => {
        swiperInitialized = true;
      });
    }
  }

  customElements.define("social-media-highlights-slider", SocialMediaHighlightsSlider);
}
